import type { RequiredGeneric } from '@pba/utils';
import { Col, Form, Row, Switch, Text, TextArea } from 'ui';
import { useUser } from 'features/auth';

export type AdditionalInfoFormValues = { displayName: boolean; reason?: string };

type P = {
  hideReason?: boolean;
};

const AdditionalInfoFormContent = <T extends AdditionalInfoFormValues = never>({
  hideReason,
}: RequiredGeneric<T, P>) => {
  const user = useUser({ requiredAuth: false });

  return (
    <>
      {hideReason ? null : (
        <Form.Item<AdditionalInfoFormValues> label="Testimonial" name="reason">
          <TextArea rows={4} size="large" />
        </Form.Item>
      )}
      <Form.Item<AdditionalInfoFormValues>>
        <Row gutter="xs">
          <Col>
            <Form.Item<AdditionalInfoFormValues> name="displayName" noStyle valuePropName="checked">
              <Switch size="small" />
            </Form.Item>
          </Col>
          <Col>
            <Text size="small">
              {user?.railsUserData ? 'Display my name and photo with my gift' : 'Display my name with my gift'}
            </Text>
          </Col>
        </Row>
      </Form.Item>
    </>
  );
};

export default AdditionalInfoFormContent;
